import { Component, OnInit } from '@angular/core';
import { PhoneCallHistoryItem } from '../models/call';
import { PhonecallService } from '../shared/phonecall.service';

@Component({
  selector: 'app-phone-calls',
  templateUrl: './phone-calls.component.html',
  styleUrls: ['./phone-calls.component.less']
})
export class PhoneCallsComponent implements OnInit {

  calls: PhoneCallHistoryItem[] = [];
  isLoading = false;
  inputValue = '';

  constructor(private phonecallService: PhonecallService) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.phonecallService.getCallHistory().subscribe({
      next: (data) => {
        this.calls = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
}
